module.exports = __webpack_public_path__ + "img/banner1.e5ba9dc3.png";